<script type="text/jsx">
    export default {
        name: 'FlexboxItem',
        props: {
            height: {
                type: [Number, String],
                default: 'auto'
            },
            bg: {
                type: String,
                default: ''
            }
        },
        computed: {
            heightRem() {
                // 效果图以360尺寸为基准
                return this.height * 1 / 36;
            },
            bg_str() {
              return `url(${this.bg}) no-repeat #fff center right`
            }
        },
        methods: {
            onItemClick() {
                this.$nextTick(() => {
                    this.$emit('on-item-click');
                });
            }
        },
        render() {
            return (
                <li onClick={ this.onItemClick }>
                    <div {...{
                        class: 'box-item',
                        style: {
                            height: `${this.heightRem}rem`,
                            background: this.bg_str,
                            backgroundSize: '48%'
                        }
                    }}>
                        { this.$slots.default }
                    </div>
                </li>
            );
        }
    }
</script>

<style lang="less" scoped>
    .box li{
        width: 50%;
        margin-bottom: 8px;
        .box-item {
            min-height: 132px;
            border-radius: 8px;
            padding: 12px;
            position: relative;
            // overflow: hidden;
        }
        &:nth-child(odd) {
            padding-right: 4px;
        }
        &:nth-child(even) {
            padding-left: 4px;
        }
        .sign-icon {
            object-fit: cover;
            position: absolute;
            top: -5px;
            right: 0;
            max-width: 100%;
            max-height: 16%;
        }
    }
    html[dir='rtl'] .box li{ 
        &:nth-child(odd) {
            padding-left: 4px;
        }
        &:nth-child(even) {
            padding-right: 4px;
        }
        .sign-icon { 
            right: unset;
            left: 0;
        }
    }
</style>